import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule, MapInfoWindow } from '@angular/google-maps';
import machinesData from '../../../assets/machines.json'; // Import danych maszyn
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { RekbotsService } from '../../services/rekbots.service';
import { Rekbot } from '../../models/rekbot.model';
import { RekbotSettings } from '../../models/rekbot-settings.model';
import { map, of, pipe } from 'rxjs';
import { ModalRekbotDetailsComponent } from '../modal-rekbot-details/modal-rekbot-details.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RekbotStatusAssets } from '../../models/rekbot-status-assets';

interface Machine {
  name: string;
  lat: number;
  lng: number;
  contact: string;
  status: number;
}

interface Marker {
  position: google.maps.LatLngLiteral;
  title: string;
}

@Component({
  selector: 'app-rekbot-map',
  standalone: true,
  imports: [
    CommonModule,
    GoogleMapsModule,
    MatIconModule,
    MatCardModule,
    ReactiveFormsModule,
    MatButtonModule

  ],
  templateUrl: './rekbot-map.component.html',
  styleUrls: ['./rekbot-map.component.scss'],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class RekbotMapComponent implements OnInit, OnDestroy {
  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;

  public dialogRef?: MatDialogRef<ModalRekbotDetailsComponent>;
  readonly dialog = inject(MatDialog);

  statusIconMap: Record<number, string> = {
    0: 'assets/img/map_pin_status_ERROR.svg',
    1: 'assets/img/map_pin_status_OK.svg',
    2: 'assets/img/map_pin_status_OFFLINE.svg',
  };  

  elementId: number;

  subscription: any;

  rekbots: Rekbot[] = [];
  //rekbots: Rekbot[] = [];

  //rekbots$:

  rekbot: Rekbot = {
    id: 0,
    serial_no: "",
    ipv4: "",
    port: 0,
    gps_device_id: "",
    status: 0,
    status_new: 0,
    namedStatus: "",
    organization_id: 0
  };

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private rekbotsService: RekbotsService,
  ) {
    this.elementId = 0;
  }

  center: google.maps.LatLngLiteral = { lat: 52.2297, lng: 21.0122 };
  zoom = 12;
  selectedPosition: google.maps.LatLngLiteral | null = null; // Pozycja wybranego markera
  markers: {
    position: google.maps.LatLngLiteral;
    title: string;
    statusAsset: RekbotStatusAssets
  }[] = []; // Lista markerów z pozycją i tytułem

  ngOnInit(): void {

    this.elementId = this.route.parent?.snapshot.params['rekbotId'];

    if (this.elementId) {
      this.fetchRekbot(this.elementId)
    }

    console.log("init", this.elementId)

    if (!this.elementId) {
      console.log("getFilteredRekbots", this.rekbotsService.getFilteredRekbots())
      this.rekbots = this.rekbotsService.getFilteredRekbots();
      // this.loadMachineMarkers();
      this.loadRekbotMarkers();
      this.zoom = 8;

      if (this.markers.length > 0) {
        console.log("markers", this.markers)
        this.setMapCenter(this.markers[0].position.lat, this.markers[0].position.lng)
      }

      /*this.subscription = this.rekbotsService.getFilteredRekbots().subscribe(
        {
          next: (response: any) => {
            console.log("getFilteredRekbots from subscription", response)
            this.rekbots = response
            this.loadRekbotMarkers();
          }
        });*/
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe;
    }
  }

  prepareRekbot(rekbot: Rekbot, settings: RekbotSettings | null = null): Rekbot {
    let fullRekbot = rekbot;
    fullRekbot.namedStatus = (fullRekbot.status === 0) ? "ERROR" : "OK"

    if(settings !== null) {
      fullRekbot.settings = rekbot.settings
    }

    if (fullRekbot.settings?.lat !== undefined && fullRekbot.settings?.lon !== undefined) {
      //this.center = { lat: parseFloat(fullRekbot.settings.lat), lng: parseFloat(fullRekbot.settings.lon) }
    }

    return fullRekbot;
  }

  setMapCenter(lat: number, lon: number): void {
    this.center = { lat: lat, lng: lon }
  }

  fetchRekbot(id: number): void {
    this.rekbotsService.fetchRekbotSettings(id)
      .subscribe({
        next: (response: any) => {

          console.log("fetchRekbot", response)

          /*let fullRekbot: Rekbot = response.rekbot
          fullRekbot.namedStatus = (fullRekbot.status === 0) ? "ERROR" : "OK"
          fullRekbot.settings = response.settings

          if (fullRekbot.settings?.lat !== undefined && fullRekbot.settings?.lon !== undefined) {
            this.center = { lat: parseFloat(fullRekbot.settings.lat), lng: parseFloat(fullRekbot.settings.lon) }
          }*/
          const rekbot = {
            ...response.rekbot,
            statusAssets: this.rekbotsService.getRekbotStatusAsset(this.rekbot.status_new)
          };
          
          const fullRekbot = this.prepareRekbot(rekbot, response.settings)

          this.rekbots.push(fullRekbot)

          this.loadRekbotMarkers();

          if (this.markers.length > 0) {
            this.setMapCenter(this.markers[0].position.lat, this.markers[0].position.lng)
          }

          console.log("markers", this.markers)

        },
        error: error => {
          console.log("fetchrekbot error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });

  }

  loadRekbotMarkers(): void {
    try {
      console.log("loadRekbotMarkers rekbots", this.rekbots)

      this.markers = this.rekbots.filter((rekbot) => ( rekbot.settings !== null && rekbot.settings?.lat !== null && rekbot.settings?.lon !== null)).map(
        (rekbot) => {

          console.log("loadRekbotMarkers rekbot mapping", rekbot)

          if (rekbot.settings?.lat !== undefined && rekbot.settings?.lon !== undefined ) {
            return {
              position: { lat: parseFloat(rekbot.settings.lat), lng: parseFloat(rekbot.settings.lon) },
              title: rekbot.serial_no,
              statusAsset: rekbot.statusAssets ?? new RekbotStatusAssets("Nieznany","whiteSmoke","assets/img/map_pin_status_UNKNOWN.svg"),
              city: rekbot.settings.city,
              street: rekbot.settings.street,
              post_code: rekbot.settings.post_code,
              rekbot: rekbot.serial_no,
              organization: rekbot.organization?.name,
              contact_person: rekbot.settings.contact_person,
              contact_company: rekbot.settings.contact_company,
              contact_phone: rekbot.settings.contact_phone,
              contact_email: rekbot.settings.contact_email,
            }
          } else {
            return {
              position: { lat: 0, lng: 0 },
              title: "Brak danych",
              rekbot: rekbot.serial_no,
              statusAsset: new RekbotStatusAssets("Nieznany","white","assets/img/map_pin_status_UNKNOWN.svg")
            }
          }
        });

        console.log("loadRekbotMarkers markers", this.markers)


    } catch (error) {
      console.error('Błąd podczas ładowania danych maszyn:', error);
    }
  }

  // loadMachineMarkers(): void {
  //   try {
  //     const machines: Machine[] = machinesData as Machine[];
  //     this.markers = machines.map(machine => ({
  //       position: { lat: machine.lat, lng: machine.lng },
  //       title: machine.name,
  //       status: machine.status
  //     }));
  //   } catch (error) {
  //     console.error('Błąd podczas ładowania danych maszyn:', error);
  //   }
  // }

  openInfoWindow(marker: { position: google.maps.LatLngLiteral; title: string }): void {

    console.log("openInfoWindow", marker)

    if (!this.infoWindow) {
      console.error('InfoWindow is not initialized');
      return;
    }

    this.selectedPosition = marker.position; // Przypisz pozycję markera
    //this.infoWindow.open(); // Otwórz InfoWindow (pozycja ustawiona w szablonie HTML)
    this.openDialog(marker);
  }
  openDialog(rekbot: any) {

    console.log("openDialog", rekbot)

    this.rekbotsService.selectedMapRekbot = rekbot;

    this.dialogRef = this.dialog.open(ModalRekbotDetailsComponent, {
      width: '800px',
    });

    this.dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed result:', result);
      //this.fetchPlanning();
      this.rekbotsService.selectedMapRekbot = null;
    });
  }

  goBack(): void {
    if (this.elementId > 0) {
      this.router.navigate(['rekbot', this.elementId])
    } else {

      this.router.navigate(['/rekbots-list']);
    }
  }
}
